
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.151 14.45h-.012v-2.123H8.064v2.123a5.367 5.367 0 01-4.81-4.811h2.122V8.564H3.254a5.362 5.362 0 014.81-4.81v2.122h1.075V3.754a5.36 5.36 0 014.811 4.81h-2.122v1.075h2.122a5.368 5.368 0 01-4.799 4.811zm-.012 3.254v-2.179a6.455 6.455 0 005.886-5.886h2.179V8.564h-2.173a6.46 6.46 0 00-5.892-5.891V.5H8.064v2.173a6.46 6.46 0 00-5.892 5.891H0v1.075h2.178a6.455 6.455 0 005.886 5.886v2.179h1.075z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/limit.svg